import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

// This marks the price ranges as translatable.
// It's picked up by lingui compile.
// We then use these mappings to translate the values.
const priceRanges = {
  range1: t`priceRange.range1`,
  range2: t`priceRange.range2`,
  range3: t`priceRange.range3`,
  range4: t`priceRange.range4`,
  range5: t`priceRange.range5`,
};

const characteristics = {
  vegan: t`vegan`,
  vegetarian: t`vegetarian`,
  organic: t`organic`,
  biodynamic: t`biodynamic`,
};

export default function useProductFacetTranslation() {
  const { i18n } = useLingui();
  return {
    priceRange(raw) {
      const mapped = priceRanges[raw] ?? priceRanges.default;
      if (!mapped) return raw;
      return i18n._(mapped);
    },

    characteristic(raw) {
      const mapped = characteristics[raw] ?? characteristics.default;
      if (!mapped) return raw;
      return i18n._(mapped);
    },
  };
}
